import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home as HomeIcon, RefreshCw } from "lucide-react";
import { API } from "@/auth";
import useSeo from "@/seo";

function displayDate(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
  return m ? `${m[3]}-${m[2]}-${m[1]}` : iso || "";
}

export default function HouseEndingPublic() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useSeo({
    title: "House & Ending Numbers | Morning Sunday Teer",
    description: "Today's Morning Sunday Teer House and Ending numbers, updated every day automatically.",
    path: "/house-ending",
  });

  const load = () => {
    setLoading(true);
    axios.get(`${API}/house-ending/today`).then((r) => setData(r.data)).finally(() => setLoading(false));
  };

  useEffect(() => {
    document.title = "House & Ending | Morning Sunday Teer";
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  const house = data?.house?.trim();
  const ending = data?.ending?.trim();

  return (
    <div className="tp-shell" data-testid="house-ending-page">
      <div className="tp-container">
        <button className="pr-back" data-testid="he-back" onClick={() => nav("/")}><ArrowLeft /> Back</button>
        <div className="tp-title-row">
          <h1 className="pr-title">House &amp; Ending</h1>
          <button className="tp-refresh" onClick={load} aria-label="Refresh"><RefreshCw size={18} /></button>
        </div>
        <p className="pr-sub">Today's House and Ending numbers, updated daily.</p>

        <div className="tp-card tp-card--he" data-testid="he-card">
          <div className="tp-date-head tp-date-head--he">
            <HomeIcon size={18} />
            <span data-testid="he-date">{loading ? "Loading..." : (data?.date ? `HOUSE & ENDING · ${displayDate(data.date)}` : "HOUSE & ENDING")}</span>
          </div>
          <div className="tp-split">
            <div>
              <small>HOUSE</small>
              <span data-testid="he-house">{loading ? "…" : (house || "—")}</span>
            </div>
            <div>
              <small>ENDING</small>
              <span data-testid="he-ending">{loading ? "…" : (ending || "—")}</span>
            </div>
          </div>
          <p className="tp-note">The values change automatically every day.</p>
        </div>
      </div>
    </div>
  );
}
